import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { TearoomMenu } from './components/tearoom'

export const TearoomHome = () => {
  const { data } = useSelector((state) => state?.tearoom)

  return (
    <Box>
      <TearoomMenu data={data} />
    </Box>
  )
}
